import React from 'react';

export function useEventMessage(messageHandler) {
	React.useEffect(() => {
		window.addEventListener('message', messageHandler);
		return () => window.removeEventListener('message', messageHandler);
	}, []);
}
